import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CreditCard, X, ExternalLink } from 'lucide-react';

export const SubscriptionMigrationInfo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  return (
    <Card className="border shadow-sm rounded-xl bg-gradient-to-r from-blue-50/80 to-white dark:from-blue-950/20 dark:to-background mb-6">
      <CardContent className="p-5">
        <div className="flex items-start gap-4">
          <div className="p-2.5 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex-shrink-0 mt-0.5">
            <CreditCard className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          </div>
          
          <div className="flex-1 min-w-0">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">
              Recover card fees on existing subscriptions
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Stop paying card processing fees on active subscriptions. Only subscriptions paid by credit card are affected.
            </p>
            
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 mt-2 transition-colors"
            >
              Learn how it works
              <ExternalLink className="h-3.5 w-3.5" />
            </button>

            {isExpanded && (
              <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 space-y-3 text-sm text-gray-500 dark:text-gray-400">
                <p>
                  Customers with card subscriptions get an email to switch to bank payments (ACH) and keep their current price.
                </p>
                <p>
                  If they stay on card, their price automatically adjusts to cover processing fees. Either way, you receive your full intended amount.
                </p>
                <p>
                  Migration runs safely on top of Stripe with no billing interruptions.
                </p>
              </div>
            )}
          </div>
          <button
            onClick={() => setIsDismissed(true)}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors flex-shrink-0 p-1"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
};
